import { pageNames } from '@atc/bonnet-paths';
import { objectDuckCreator } from '@atc/modular-redux';

export default objectDuckCreator({
    namespace: '',
    store: 'crawlPath',
    storePrefix: `${pageNames.DEALER_SEARCH}.`,
});
